/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EntityType {
  Organization = 1,
  Tenant = 2,
  Contractor = 3,
  PropertyManager = 4,
  Investor = 5,
  Unit = 6,
  Property = 7,
  ServiceRequest = 8,
}
